import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { RestaurantTable } from "../utils/interfaces";

export const posOrderTableMethodAtom = atomWithStorage<null | RestaurantTable>(
  "posTable",
  null
);

const usePosOrderTable = () => {
  const atom = useAtom(posOrderTableMethodAtom);
  return atom;
};

export const useSetPosOrderTable = () => useSetAtom(posOrderTableMethodAtom);

export default usePosOrderTable;
